// test1512
(1512 && 0);
